import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

Vue.use(Vuex)

const storagePlugin = store => {
  let saved_data = JSON.parse(window.sessionStorage.wirvuex || '{}')
  let new_state = {}

  Object.assign(new_state, store.state, saved_data)
  store.replaceState(new_state)

  store.subscribe((_mutation, state) => {
    try {
      window.sessionStorage.wirvuex = JSON.stringify(state)
    } catch (e) {
      // i hate you safari
    }
  })
}

export default new Vuex.Store({
  plugins: [storagePlugin],
  state: {
    user: null,
    cwd: {},
    requestingAccess: null,
    searchResults: [],
    searchDisplay: false,
    sortMethod: '',
  },
  mutations: {
    USER(state, data) {
      state.user = data
    },
    CWD(state, data) {
      state.cwd = data
    },
    REQUEST_ACCESS(state, folder_id) {
      state.requestingAccess = folder_id
    },
    SEARCH_RESULTS(state, res) {
      state.searchResults = res
      state.searchDisplay = true
    },
    SEARCH_DISPLAY(state, show) {
      state.searchDisplay = show

      if (show == false) {
        state.searchResults = []
      }
    },
    SORT_METHOD(state, method) {
      state.sortMethod = method
    }
  },
  actions: {
    async logout({commit}) {
      await axios.post('/api/logout')
      commit('USER', null)
    },
    setUser({commit}, user) {
      commit('USER', user)
    },
    setCwd({commit}, cwd) {
      commit('CWD', cwd)
    },
    async showRequestAccess({commit}, folder_id) {
      if (folder_id !== null) {
        let r = await axios.get(`/api/files/public-folder-data/${folder_id}`)

        if (r.status != 200) {
          return;
        }

        commit('REQUEST_ACCESS', r.data)
      }
      else {
        commit('REQUEST_ACCESS', null)
      }
    },
    async search({commit}, q) {
      let r = await axios.get('/api/files/search', {
        params: {
          q: q
        }})

      if (r.status != 200) {
        return;
      }
      commit('SEARCH_RESULTS', r.data.files)
    },
    setSearchDisplay({commit}, show) {
      commit('SEARCH_DISPLAY', show)
    },
    setSortMethod({commit}, method) {
      commit('SORT_METHOD', method)
    }
  }
})
